    <aside *ngIf="visible" #bar
      class="bo-2026 bo-contextual-savebar" [class.is-saved]="saved && !dirty" [class.has-error]="errorKey"
      [attr.aria-label]="contextText || (contextKey | translate)">
      <div class="bo-contextual-savebar__state" role="status" aria-live="polite" aria-atomic="true">
        <span class="bo-contextual-savebar__indicator" aria-hidden="true">
          <span *ngIf="saving" class="spinner-border spinner-border-sm"></span>
          <i *ngIf="!saving" class="bi" [ngClass]="errorKey ? 'bi-exclamation-circle' : (saved && !dirty ? 'bi-check2' : 'bi-circle-fill')"></i>
        </span>
        <div><span class="bo-contextual-savebar__label">{{ (saving ? 'ac_saving' : (saved && !dirty ? 'bo_changes_saved' : 'bo_unsaved_changes')) | translate }}</span>
          <span class="bo-contextual-savebar__context">{{ errorKey ? (errorKey | translate) : (contextText || (contextKey | translate)) }}</span>
        </div>
      </div>
      <div class="bo-contextual-savebar__actions" *ngIf="dirty || saving">
        <button type="button" class="bo-btn bo-btn--settings" [disabled]="actionsDisabled" (click)="requestDiscard()">{{ 'ac_discard' | translate }}</button>
        <button type="button" (click)="requestSave()" class="bo-btn bo-btn--settings bo-btn--primary" [disabled]="actionsDisabled">
          <i *ngIf="!saving" class="bi bi-check2" aria-hidden="true"></i>
          {{ (saving ? 'ac_saving' : 'bo_save_changes') | translate }}
        </button>
      </div>
    </aside>
